import Typography from '@mui/material/Typography';
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@mui/styles/styled';

const Container = styled('div')(({ theme }) => ({
	display: 'flex',
	flexFlow: 'row nowrap',
	alignItems: 'center',
	marginRight: theme.spacing(4),
}));

const Side = styled('div')({
	display: 'inline-flex',
});

const Title = styled(Side)(({ theme }) => ({
	flex: 0,
	padding: `${theme.spacing(2)}px ${theme.spacing(2.5)}px ${theme.spacing(
		2
	)}px 0`,
	verticalAlign: 'top',
}));

function EtaRow({ title, ...props }) {
	return (
		<Container {...props}>
			<Title>
				<Typography variant="body">{title}</Typography>
			</Title>
		</Container>
	);
}

EtaRow.propTypes = {
	title: PropTypes.object,
};

export default EtaRow;
